import { render, staticRenderFns } from "./deadline-list.vue?vue&type=template&id=393a226b"
import script from "./deadline-list.vue?vue&type=script&lang=js"
export * from "./deadline-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports